import { lazy } from 'react'

const AccessControl = {
  Control: lazy(() => import('./Control')),
  CreateRule: lazy(() => import('./CreateRule')),
  NatList: lazy(() => import('./NatList')),
}

export default AccessControl